var React;

function requireReactLazily() {
  return React || (React = require('react'));
}

export { requireReactLazily };